import styled from 'styled-components'
import PredictionButton from '@app.feature/exam/gsat2024-2/components/button/PredictionButton.desktop'
import AccessRestrictionNotice from '@app.feature/exam/gsat2024-2/desktop/components/notice/AccessRestrictionNotice.desktop'

const StepFourAccessRestrictionNoticeMobile = () => {
  const isOpenAccessRestrictionNotice = false

  if (!isOpenAccessRestrictionNotice) {
    return null
  }

  return (
    <AccessRestrictionNotice>
      <StyledWrapper>
        <strong className="notice-text">
          서비스 이용 신청 후<br />
          GSAT 난이도 투표가 가능합니다.
        </strong>
        <PredictionButton color="primary">서비스 이용 신청</PredictionButton>
      </StyledWrapper>
    </AccessRestrictionNotice>
  )
}

export default StepFourAccessRestrictionNoticeMobile

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 50px;
  > .notice-text {
    font-size: 44px;
    font-weight: bold;
    line-height: 1.34;
    letter-spacing: -1.76px;
    text-align: center;
    color: #fff;
  }
`
